import MathTool from '../math/MathTool.js';
import DrawTool from '../draw/DrawTool.js';

let p5;
export default class MosaicCircle{
    constructor( x, y, radius, pieceSize, piecePad, colorRules ){
        p5 = window.p5App;
        this.x = x;
        this.y = y;
        this.radius = radius;
        this.pieceSize = pieceSize;
        this.piecePad = piecePad;
        this.colorRules = colorRules;
        this.draw();
    }

    draw(){
        
        console.log("MosaicCircle::draw()");
        p5.push();
        p5.translate( this.x, this.y);
        p5.stroke('#332f27ff');
        p5.strokeWeight(5);
        p5.fill('#332f27ff');
        p5.circle( 0, 0, this.radius*2 );

        p5.noStroke();

        //p5.rectMode( p5.CENTER)

        //p5.stroke('#000000FF');
        for (let r = 0; r < this.colorRules.length; r++) {
            let currentRadius = this.radius - r*(this.pieceSize+this.piecePad*2);
            let perimeter = 2 * Math.PI * currentRadius;
            let numPieces = Math.floor(perimeter / (this.pieceSize+this.piecePad*2) );
            let currentAngle = 0;
            let i = 0;
            let pieceAngle = (Math.PI*2) / numPieces;
            //console.log( "numPices: ", perimeter, numPieces);
            //for (let i = 0; i < numPieces; i++) {
                while( currentAngle<Math.PI*2){
                let pieceAngleModifier = MathTool.random()*0.9+0.1;
                let thisPieceAngle = pieceAngle*pieceAngleModifier;
                let clr = this.colorRules[r](i);
                
                /* if( MathTool.random() < 0.98 )
                    clr = p5.color( 200, 50, 50+MathTool.random()*10-5 );
                else
                    clr = p5.color( 200, 50, 30+MathTool.random()*10-5 ); */
                p5.fill(clr);
                let angleRad = currentAngle;
                //let angleRad = Math.PI*2 * (i/numPieces);
                let x = Math.cos( angleRad ) * (currentRadius-this.pieceSize);
                let y = Math.sin( angleRad ) * (currentRadius-this.pieceSize);
                p5.push();
                p5.translate( x/* +MathTool.random()-.5 */, y/* +MathTool.random()-.5 */ );
                p5.rotate( angleRad/* +MathTool.random()*0.1-0.05 */ );
                p5.strokeWeight(0.5);
               /*  p5.stroke('#332f27ff');
                p5.strokeWeight(0.5+MathTool.random()); */
                //p5.rect( 0,0, this.pieceSize, this.pieceSize+MathTool.random()*this.pieceSize-this.pieceSize*.5 );
                DrawTool.roundRect( p5.drawingContext, 0,0, this.pieceSize, this.pieceSize*pieceAngleModifier, this.piecePad*2, clr, '#000000');
                /* p5.fill('#ff0000');
                p5.circle( 0,0,2);
                p5.noFill();
                p5.stroke('#00ff00');
                p5.line(0,0,this.pieceSize, this.pieceSize*pieceAngleModifier); */
                //p5.rect( 0,0, this.pieceSize, this.pieceSize+MathTool.random()*this.pieceSize-this.pieceSize*.5 );
                currentAngle += thisPieceAngle+MathTool.random()*0.00008;
                p5.pop();
                i++;
                
            }                
        }
        p5.pop();
        //p5.line( 0, 0, 1000, 1000 );      
    }
}